import {DEFAULT_ATTRIBUTES} from "_src/engine/utility/attributes";
import {Geometry, GeometryBuffer} from "_src/engine/geometry";
import config from "_src/config";

export default class LoaderBase {
  prepareGeometry(data) {
    const layout = {};

    for (let i = 0; i < DEFAULT_ATTRIBUTES.length; ++i) {

      const name = DEFAULT_ATTRIBUTES[i];
      const attribute = data[name];

      if (attribute) {

        const attributeBuffer = data[name].buffer;
        const type = data[name].type;

        layout[name] = new GeometryBuffer({ buffer : attributeBuffer.buffer, type : type });
        if (config.viewOnlyMode /*&& !DEPENDENT_BUFFER_NAMES.includes(name)// add this check if you want to calculate normals*/) {
          layout[name].scheduleUnload();
        }

      }

    }

    const geometry = new Geometry({
      bbox     : data.bbox,
      layout   : layout,
    });

    return geometry;

  }
}
